import React from "react";
import Carousel from "react-slick";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(() => ({
  imageContainer: {
    position: "relative", // Ensure the container is positioned relative
  },
  carouselImage: {
    width: "100%",
    height: "auto",
    maxHeight: "60vh",
    objectFit: "contain",
  },
  slickCaption: {
    position: "absolute",
    top: "20px", // Changed from bottom to top
    left: "50%",
    transform: "translateX(-50%)", // Centers the caption horizontally
    color: "#fff",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    padding: "10px",
    borderRadius: "5px",
    zIndex: 2,
    width: "auto",
    minWidth: "200px",
    maxWidth: "80%",
    textAlign: "center",
  },
}));

function CarouselVar({ images }) {
  const classes = useStyles();
  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };

  return (
    <Carousel {...settings}>
      {images.map((image, index) => (
        <div key={index} className={classes.imageContainer}>
          <img src={image.src} alt={image.alt} className={classes.carouselImage} />
          <div className={classes.slickCaption}>
            <h4>{image.location}</h4>

          </div>
        </div>
      ))}
    </Carousel>
  );
}

export default CarouselVar;